// extracted by mini-css-extract-plugin
export default {"base":"AppName_base__NJ+U6"};